import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

const Home = () => {
  const location = useLocation();
  return <Redirect to={{ pathname: '/client/home', search: location.search }} />;
};

export default Home;
